import {UserService} from "../resource";

const UserModule = {
	namespaced: true,
	state: {
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, params) {
			return UserService.UserCreate(params);
		},

		updateData({ commit, state }, params) {
			return UserService.UserUpdate(params.id,params.payload);
		},

		deleteData({ commit, state }, params) {
			return UserService.UserDelete(params);
		},

		async listData({ commit, state }, params) {
			try
			{
				const response = await UserService.UserList(params);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		},
		changePassword({ commit, state }, params) {
			return UserService.ChangeUserPasswordByAdmin(params.id,params.payload);
		},
		

	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getGroupTable(state) {
			return [
				{name:"Admin",id:1},
				{name:"Owner",id:2},
				{name:"Employee",id:3},
				{name:"Agent",id:4},
				{name:"Delivery",id:5},
				{name:"Customer",id:6},
			];
		}
	},
};

export default UserModule;